import PropTypes from 'prop-types';
import MessageAttachmentShape from 'app/shapes/MessageAttachmentShape';
import CallListingShape from 'app/shapes/CallListingShape';

const MessageDetailsShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  subject: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  messageType: PropTypes.string.isRequired,
  paymentAmount: PropTypes.number,
  listing: CallListingShape,
  sender: PropTypes.shape({
    id: PropTypes.number.isRequired,
    login: PropTypes.string.isRequired,
    isAdvisor: PropTypes.bool.isRequired,
    customerId: PropTypes.number,
  }).isRequired,
  isPaid: PropTypes.bool.isRequired,
  attachments: PropTypes.arrayOf(MessageAttachmentShape).isRequired,
  description: PropTypes.string,
  body: PropTypes.string,
  recipients: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    login: PropTypes.string.isRequired,
    isAdvisor: PropTypes.bool.isRequired,
    customerId: PropTypes.number,
  })),
  recipientCount: PropTypes.number.isRequired,
});

export default MessageDetailsShape;
